import { useRef } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { IoMdCloseCircleOutline } from "react-icons/io";

export const VideoModal = ({ isOpen, videoUrl, onClose }) => {
  const videoRef = useRef(null);
  const reduceMotion = useReducedMotion();

  const linkAccess = localStorage.getItem("role");

  return createPortal(
    <AnimatePresence>
    {isOpen && <motion.div
      key="video-modal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: reduceMotion ? 0 : 0.2 }}
      className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50 p-4"
    >
      <motion.div
        role="dialog"
        aria-modal="true"
        aria-label="Video player"
        initial={{ opacity: 0, y: reduceMotion ? 0 : 24, scale: reduceMotion ? 1 : 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: reduceMotion ? 0 : 16, scale: reduceMotion ? 1 : 0.96 }}
        transition={{ duration: reduceMotion ? 0 : 0.2, ease: "easeOut" }}
        className="w-[350px] max-w-full md:w-[550px] lg:w-[700px] max-h-[calc(100dvh-2rem)] overflow-y-auto bg-white p-1 rounded-lg shadow-xl relative"
      >
        <div className="flex flex-col gap-3 items-center">
          <button type="button" aria-label="Close video" onClick={onClose}>
          <IoMdCloseCircleOutline
            size={30}
            className="cursor-pointer text-red-600 hover:text-red-800 text-3xl focus:outline-none"
          />
          </button>
          <iframe
            ref={videoRef}
            className="w-full h-[400px] rounded-md"
            src={videoUrl}
            title="Video Player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        {/* ✅ Show link section using videoUrl instead of link */}
        {videoUrl && linkAccess === "Admin" && (
          <div className="p-4 text-center bg-gray-100">
            <h2 className="text-blue-900 capitalize">Video Link</h2>
            <div className="scrollable-div text-center p-2 border-2 border-teal-500 rounded-full bg-white shadow-md overflow-auto max-h-24">
              <p className="text-blue-800 break-words">{videoUrl}</p>
            </div>
          </div>
        )}
      </motion.div>
    </motion.div>}
    </AnimatePresence>,
    document.body,
  );
};
